const actions = {
    CREATE_ACCESS_REQUEST: 'CREATE_ACCESS_REQUEST',
    CREATE_ACCESS_SUCCESS: 'CREATE_ACCESS_SUCCESS',
    CREATE_ACCESS_ERROR: 'CREATE_ACCESS_ERROR',
    READ_ACCESSES_REQUEST: 'READ_ACCESSES_REQUEST',
    READ_ACCESSES_SUCCESS: 'READ_ACCESSES_SUCCESS',
    READ_ACCESSES_ERROR: 'READ_ACCESSES_ERROR',
    READ_ACCESS_REQUEST: 'READ_ACCESS_REQUEST',
    READ_ACCESS_SUCCESS: 'READ_ACCESS_SUCCESS',
    READ_ACCESS_ERROR: 'READ_ACCESS_ERROR',
    ACCESS_SET: 'ACCESS_SET',
    ACCESS_SET_TYPE: 'ACCESS_SET_TYPE',
    UPDATE_ACCESS_REQUEST: 'UPDATE_ACCESS_REQUEST',
    UPDATE_ACCESS_SUCCESS: 'UPDATE_ACCESS_SUCCESS',
    UPDATE_ACCESS_ERROR: 'UPDATE_ACCESS_ERROR',
    INVITE_ACCESS_REQUEST: 'INVITE_ACCESS_REQUEST',
    INVITE_ACCESS_SUCCESS: 'INVITE_ACCESS_SUCCESS',
    INVITE_ACCESS_ERROR: 'INVITE_ACCESS_ERROR',
    DELETE_ACCESS_REQUEST: 'DELETE_ACCESS_REQUEST',
    DELETE_ACCESS_SUCCESS: 'DELETE_ACCESS_SUCCESS',
    DELETE_ACCESS_ERROR: 'DELETE_ACCESS_ERROR',
    MAKE_OWNER_REQUEST: 'MAKE_OWNER_REQUEST',
    MAKE_OWNER_SUCCESS: 'MAKE_OWNER_SUCCESS',
    MAKE_OWNER_ERROR: 'MAKE_OWNER_ERROR',
    ACCESS_SET_CLIENT_ID: 'ACCESS_SET_CLIENT_ID',

    UPDATE_USER_PARTNER_ACCESS_REQUEST: 'UPDATE_USER_PARTNER_ACCESS_REQUEST',
    UPDATE_USER_PARTNER_ACCESS_SUCCESS: 'UPDATE_USER_PARTNER_ACCESS_SUCCESS',
    UPDATE_USER_PARTNER_ACCESS_ERROR: 'UPDATE_USER_PARTNER_ACCESS_ERROR',

    TOGGLE_PERMISSION_TREE_MODAL: 'TOGGLE_PERMISSION_TREE_MODAL',
    SET_PERMISSION_KEYS: 'SET_PERMISSION_KEYS',

    RESET_ACCESS: 'RESET_ACCESS',

    createAccess: request => ({
        type: actions.CREATE_ACCESS_REQUEST,
        request,
    }),
    // clientId is only passed in when reading a client's accesses in partner switch plan modal
    readAccesses: (request, clientId) => ({
        type: actions.READ_ACCESSES_REQUEST,
        request,
        clientId,
    }),
    readAccess: id => ({
        type: actions.READ_ACCESS_REQUEST,
        id,
    }),
    setAccess: (request, reset = false) => ({
        type: actions.ACCESS_SET,
        request,
        reset,
    }),
    setType: val => ({
        type: actions.ACCESS_SET_TYPE,
        val,
    }),
    updateAccess: (id, request) => ({
        type: actions.UPDATE_ACCESS_REQUEST,
        id,
        request,
    }),
    inviteAccess: id => ({
        type: actions.INVITE_ACCESS_REQUEST,
        id,
    }),
    deleteAccess: id => ({
        type: actions.DELETE_ACCESS_REQUEST,
        id,
    }),
    makeOwner: id => ({
        type: actions.MAKE_OWNER_REQUEST,
        id,
    }),
    setClientId: clientId => ({
        type: actions.ACCESS_SET_CLIENT_ID,
        clientId,
    }),
    updateUserPartnerAccess: request => ({
        type: actions.UPDATE_USER_PARTNER_ACCESS_REQUEST,
        request, // { partner_manage_users: Boolean }
    }),
    togglePermissionTreeModal: value => ({
        type: actions.TOGGLE_PERMISSION_TREE_MODAL,
        value,
    }),
    setPermissionKeys: keys => ({
        type: actions.SET_PERMISSION_KEYS,
        keys,
    }),
    resetAccess: () => ({
        type: actions.RESET_ACCESS,
    }),
};
export default actions;
